<app-date-input
  appValidationContext
  [ngModel]="model"
  [minDate]="effectiveDate || firstUseDate"
  [disabled]="isDisabled || isLoading"
  (ngModelChange)="onChange($event)"
>
  <div *invalidMessageFor="'required'" class="invalid-feedback">
    End Date is required
  </div>
  <div *invalidMessageFor="'min'" class="invalid-feedback">
    End Date must be after First Use Date
  </div>
  <div *invalidMessageFor="'minDate'" class="invalid-feedback">
    End Date must be after First Use Date
  </div>
  <div *invalidMessageFor="'remainingLife'" class="invalid-feedback">
    Remaining Life must be greater than zero
  </div>
</app-date-input>
